import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import validator from "validator";
import "../../styles/etapas.css";

// components
import Input from "../input/Input";

const StepOne = ({ nextStep, handleFormData, values }) => {
  const [error, setError] = useState(false);
  const submitFormData = (e) => {
    e.preventDefault();
    if (
      validator.isEmpty(values.dtNascimento) ||
      // validator.isEmpty(values.dependente) ||
      // validator.isEmpty(values.autorizo) ||
      validator.isEmpty(values.estadoCivil) ||
      validator.isEmpty(values.sexo) ||
      validator.isEmpty(values.tipoDoc) ||
      validator.isEmpty(values.docIdentificacao) ||
      validator.isEmpty(values.orgEmissor) ||
      validator.isEmpty(values.dtEmissao) ||
      validator.isEmpty(values.escolaridade) ||
      validator.isEmpty(values.ultimaSerie) ||
      validator.isEmpty(values.nomePai) ||
      validator.isEmpty(values.nomeMae) ||
      validator.isEmpty(values.naturalidade) ||
      validator.isEmpty(values.fone1) ||
      validator.isEmpty(values.nacionalidade)
    ) {
      setError(true);
    } else {
      nextStep();
    }
  };

  return (
    <>
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0 ">
            <div className="row">
              <div className="col-lg">
                <div className="p-5">
                  <div className="text-center">
                    <h5 className="h5 text-gray-900 mb-4">
                      CADASTRO CLIENTE <br />
                      <small style={{ fontSize: "14px" }}>
                        Trabalhador do Comércio
                      </small>
                    </h5>
                    <br />

                    <div className="card card-timeline px-1 border-none mb-5">
                      <ul className="bs4-order-tracking">
                        <li className="step active">
                          <div>
                            <i className="fas fa-user"></i>
                          </div>
                          <label style={{ fontSize: "10px" }}>pessoal </label>
                        </li>
                        <li>
                          <div>
                            <i className="far fa-envelope-open"></i>
                          </div>
                          <label style={{ fontSize: "10px" }}> endereço</label>
                        </li>
                        <li>
                          <div>
                            <i className="far fa-address-card"></i>
                          </div>
                          <label style={{ fontSize: "10px" }}>
                            profissional
                          </label>
                        </li>
                        <li className="step ">
                          <div>
                            <i className="fas fa-file-upload"></i>
                          </div>
                          <label style={{ fontSize: "10px" }}>
                            documentação
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* formulario de cadastro  */}

                  <form className="user" onSubmit={submitFormData}>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>NOME</label>

                        <input
                          className="form-control "
                          onChange={handleFormData("nome")}
                          name="nome"
                          defaultValue={values.nome}
                          disabled
                        />
                      </div>
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>CPF</label>

                        <input
                          className="form-control "
                          onChange={handleFormData("cpf")}
                          name="cpf"
                          defaultValue={values.cpf}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label style={{ fontSize: "10px" }}>NOME SOCIAL</label>
                      <input
                        type="text"
                        className="form-control "
                        onChange={handleFormData("nomeSocial")}
                        name="nomeSocial"
                        defaultValue={values.nomeSocial}
                        style={{
                          textTransform: "uppercase",
                        }}
                      />
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-4 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>NASCIMENTO</label>
                        <input
                          style={{
                            border:
                              !values.dtNascimento && error
                                ? "2px solid red"
                                : "",
                          }}
                          type="date"
                          className="form-control "
                          onChange={handleFormData("dtNascimento")}
                          name="dtNascimento"
                          defaultValue={values.dtNascimento}
                        />
                        {!values.dtNascimento && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-sm-2">
                        <label style={{ fontSize: "9px" }}>
                          Nº DE DEPEDENTES
                        </label>
                        <input
                          type="number"
                          className="form-control "
                          style={{
                            border:
                              !values.dependente && error
                                ? "2px solid red"
                                : "",
                          }}
                          onChange={handleFormData("dependente")}
                          name="dependente"
                          defaultValue={values.dependente}
                        />

                        {!values.dependente && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-sm-4  ">
                        <label style={{ fontSize: "10px" }}>ESTADO CIVIL</label>
                        <select
                          id="estadoCivil"
                          className="form-control"
                          style={{
                            border:
                              !values.estadoCivil && error
                                ? "2px solid red"
                                : "",
                          }}
                          onChange={handleFormData("estadoCivil")}
                          name="estadoCivil"
                          defaultValue={values.estadoCivil}
                        >
                          <option>Selecione</option>
                          <option value="1">Solteiro</option>
                          <option value="2">Casado</option>
                          <option value="3">Viúvo</option>
                          <option value="4">Divorciado</option>
                          <option value="5">Separado</option>
                          <option value="6">União Estável</option>
                        </select>

                        {!values.estadoCivil && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-sm-2">
                        <label style={{ fontSize: "10px" }}>SEXO</label>
                        <select
                          id="sexo"
                          className="form-control"
                          style={{
                            border:
                              !values.sexo && error ? "2px solid red" : "",
                          }}
                          onChange={handleFormData("sexo")}
                          name="sexo"
                          defaultValue={values.sexo}
                        >
                          <option>Selecione</option>
                          <option value="1">Feminino</option>
                          <option value="2">Masculino</option>
                        </select>

                        {!values.sexo && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>
                    </div>

                    <hr className="mt-4" />

                    {/*   IDENTIFICAÇÃO OFICIAL */}

                    <div className="text-center">
                      <small className="small text-gray-900 mb-4">
                        IDENTIDADE
                      </small>
                    </div>

                    <hr className="mt-4" />

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>
                          TIPO DOCUMENTO IDENTIFICAÇÃO
                        </label>

                        <select
                          id="tipoDoc"
                          className="form-control"
                          style={{
                            border:
                              !values.tipoDoc && error ? "2px solid red" : "",
                          }}
                          onChange={handleFormData("tipoDoc")}
                          name="tipoDoc"
                          defaultValue={values.tipoDoc}
                        >
                          <option value=""> Selecione </option>
                          <option value="1">Carteira de Identidade</option>
                          <option value="2">
                            Carteira Nacional de Habilitação
                          </option>
                          <option value="3">
                            Carteira de Registro Profisisonal
                          </option>
                          <option value="4">Carteira de Trabalho</option>
                          <option value="5">Certidão de Nascimento</option>
                          <option value="6">Certificado de Reservista</option>
                          <option value="7">Passaporte</option>
                          <option value="8">
                            Registro Nacional de Estrangeiro
                          </option>
                        </select>

                        {!values.tipoDoc && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>
                          Nº DOCUMENTO DE IDENTIFICAÇÃO
                        </label>

                        <input
                          type="text"
                          className="form-control "
                          placeholder="Nº Documento"
                          style={{
                            border:
                              !values.docIdentificacao && error
                                ? "2px solid red"
                                : "",
                          }}
                          onChange={handleFormData("docIdentificacao")}
                          name="docIdentificacao"
                          defaultValue={values.docIdentificacao}
                        />

                        {!values.docIdentificacao && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-4 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>
                          ORGÃO EMISSOR
                        </label>
                        <input
                          type="text"
                          className="form-control "
                          placeholder="Ex.: SSP-AL"
                          style={{
                            border:
                              !values.orgEmissor && error
                                ? "2px solid red"
                                : "",
                          }}
                          onChange={handleFormData("orgEmissor")}
                          name="orgEmissor"
                          defaultValue={values.orgEmissor}
                        />

                        {!values.orgEmissor && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>
                      <div className="col-sm-4">
                        <label style={{ fontSize: "10px" }}>DATA EMISSÃO</label>
                        <input
                          type="date"
                          className="form-control "
                          placeholder="Data de emissão"
                          style={{
                            border:
                              !values.dtEmissao && error ? "2px solid red" : "",
                          }}
                          onChange={handleFormData("dtEmissao")}
                          name="dtEmissao"
                          defaultValue={values.dtEmissao}
                        />

                        {!values.dtEmissao && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>
                    </div>

                    <hr className="mt-4" />

                    {/*  ESCOLARIDADE  */}

                    <div className="form-group row">
                      <div className="col-sm-3 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>ESCOLARIDADE</label>
                        <select
                          id="escolaridade"
                          className="form-control"
                          style={{
                            border:
                              !values.escolaridade && error
                                ? "2px solid red"
                                : "",
                          }}
                          onChange={handleFormData("escolaridade")}
                          name="escolaridade"
                          defaultValue={values.escolaridade}
                        >
                          <option value="">Selecione</option>
                          <option value="1">Sem escolaridade</option>
                          <option value="2">Analfabeto</option>
                          <option value="3">Alfabetizado</option>
                          <option value="4">Ensino fundamental completo</option>
                          <option value="5">
                            Ensino fundamental incompleto
                          </option>
                          <option value="6">Ensino médio completo</option>
                          <option value="7">Ensino médio incompleto</option>
                          <option value="8">Ensino superior completo</option>
                          <option value="9">Ensino superior incompleto</option>
                          <option value="10">Pós-graduação completa</option>
                          <option value="11">Pós-graduação incompleta</option>
                          <option value="12">Mestrado</option>
                        </select>

                        {!values.escolaridade && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-sm-3">
                        <label style={{ fontSize: "10px" }}>ÚLTIMA SÉRIE</label>
                        <input
                          type="text"
                          className="form-control "
                          style={{
                            border:
                              !values.ultimaSerie && error
                                ? "2px solid red"
                                : "",
                          }}
                          onChange={handleFormData("ultimaSerie")}
                          name="ultimaSerie"
                          defaultValue={values.ultimaSerie}
                        />

                        {!values.ultimaSerie && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-sm-3">
                        <label style={{ fontSize: "10px" }}>
                          AINDA É ESTUDANTE?
                        </label>
                        <br />

                        <div className="form-check form-check-inline mt-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="estudanteRadio1"
                            value="S"
                            onChange={handleFormData("estudante")}
                            name="estudante"
                            required
                          />
                          <label className="form-check-label">SIM</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="estudanteRadio2"
                            value="N"
                            onChange={handleFormData("estudante")}
                            name="estudante"
                            required
                          />
                          <label className="form-check-label">NÃO</label>
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <label style={{ fontSize: "10px" }}>
                          PESSOA COM DEFICIÊNCIA?
                        </label>
                        <br />

                        <div className="form-check form-check-inline mt-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="deficiente"
                            id="deficienciaRadio1"
                            value="S"
                            onChange={handleFormData("deficiente")}
                            required
                          />
                          <label className="form-check-label">SIM</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="deficiente"
                            id="deficienciaRadio2"
                            value="N"
                            onChange={handleFormData("deficiente")}
                            required
                          />
                          <label className="form-check-label">NÃO</label>
                        </div>
                      </div>
                    </div>

                    {/*   FILIAÇÃO */}

                    <div className="form-group">
                      <label style={{ fontSize: "10px" }}>NOME DO PAI</label>
                      <input
                        type="text"
                        className="form-control "
                        name="nomePai"
                        style={{
                          border:
                            !values.ultimaSerie && error ? "2px solid red" : "",
                          textTransform: "uppercase",
                        }}
                        onChange={handleFormData("nomePai")}
                        defaultValue={values.nomePai}
                      />
                      {!values.nomePai && error && (
                        <Form.Text style={{ color: "red" }}>
                          Este é um campo obrigatório
                        </Form.Text>
                      )}
                    </div>

                    <div className="form-group">
                      <label style={{ fontSize: "10px" }}>NOME DA MÃE</label>
                      <input
                        type="text"
                        className="form-control "
                        name="nomeMae"
                        style={{
                          border:
                            !values.nomeMae && error ? "2px solid red" : "",
                          textTransform: "uppercase",
                        }}
                        onChange={handleFormData("nomeMae")}
                        defaultValue={values.nomeMae}
                      />

                      {!values.nomeMae && error && (
                        <Form.Text style={{ color: "red" }}>
                          Este é um campo obrigatório
                        </Form.Text>
                      )}
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>NATURALIDADE</label>
                        <input
                          type="text"
                          className="form-control "
                          name="naturalidade"
                          placeholder="Ex.: ALAGOAS"
                          style={{
                            border:
                              !values.naturalidade && error
                                ? "2px solid red"
                                : "",
                            textTransform: "uppercase",
                          }}
                          onChange={handleFormData("naturalidade")}
                          defaultValue={values.naturalidade}
                        />

                        {!values.naturalidade && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>
                          NACIONALIDADE
                        </label>

                        <input
                          type="text"
                          className="form-control "
                          name="nacionalidade"
                          placeholder="Ex.: BRASILEIRA"
                          style={{
                            border:
                              !values.nacionalidade && error
                                ? "2px solid red"
                                : "",
                            textTransform: "uppercase",
                          }}
                          onChange={handleFormData("nacionalidade")}
                          defaultValue={values.nacionalidade}
                        />

                        {!values.nacionalidade && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>CELULAR</label>

                        <Input
                          style={{
                            border:
                              !values.fone1 && error ? "2px solid red" : "",
                          }}
                          className="form-control "
                          id="fone1"
                          name="fone1"
                          placeholder="xx xxxxx-xxxx"
                          onChange={handleFormData("fone1")}
                          defaultValue={values.fone1}
                          mask="telefone"
                        />

                        {!values.fone1 && error && (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>TELEFONE</label>

                        <Input
                          type="text"
                          className="form-control "
                          onChange={handleFormData("fone2")}
                          name="fone2"
                          defaultValue={values.fone2}
                          mask="telefone1"
                          placeholder="xx xxxx-xxxx"
                        />
                      </div>
                    </div>

                    <div className="col-sm-7 mt-4 mb-4">
                      <label style={{ fontSize: "10px" }}>
                        Termo de Aceite
                      </label>
                      <br />

                      <div className="form-check form-check-inline mt-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="check_lgpd"
                          required
                        />

                        <a
                          href={
                            "https://sescalagoas.com.br/institucional/politicas"
                          }
                          target="_blank"
                          className="small"
                          rel="noreferrer"
                        >
                          Autorizo o tratamento dos meus Dados Pessoais
                        </a>
                      </div>
                    </div>

                    <Button
                      type="submit"
                      className="btn btn-primary btn-user btn-block"
                    >
                      Continue
                    </Button>
                  </form>

                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepOne;
